import { FlowRestRequestBodyFormat, FlowRestResponseBodyFormat } from 'flow-schema';

export const sharedRestBlockDefaultConfig = {
  endpoint: 'https://jsonplaceholder.typicode.com/todos/1',
  method: 'GET' as const,
  secureHeaders: [],
  bodyFormat: FlowRestRequestBodyFormat.RawJson,
  responseBodyFormat: FlowRestResponseBodyFormat.AutoDetect,
};
